module.exports = __webpack_public_path__ + "img/file.43f853b9.svg";